export enum NotificationEvents {
    TourHadVerified = 'TourHadVerified',

    TourNotVerified = 'TourNotVerified',

    VerifiedTourSold = 'VerifiedTourSold',

    ClickOnFlightEndPoint = 'ClickOnFlightEndPoint',

    ClickOnWrongDestinationTip = 'ClickOnWrongDestinationTip',

    ClickOnAirCompanyTip = 'ClickOnAirCompanyTip',

    ClickOnTourPriceStatusTip = 'ClickOnTourPriceStatusTip',

    ClickOnTotalReviewsRating = 'ClickOnTotalReviewsRating',

    ClickOnTourVerifiedTooltip = 'ClickOnTourVerifiedTooltip',

    ClickOnTourNotVerifiedTooltip = 'ClickOnTourNotVerifiedTooltip',

    TourDetailsCopySuccess = 'TourDetailsCopySuccess',

    TourDetailsCopyFail = 'TourDetailsCopyFail',

    AddTourToBasketSuccess = 'AddTourToBasketSuccess',

    Nothing = 'Nothing'
}


export type TourDetailsCopyResultEvent = NotificationEvents.TourDetailsCopySuccess | NotificationEvents.TourDetailsCopyFail;

export type TourActualizationResultEvent = NotificationEvents.ClickOnTourVerifiedTooltip |
    NotificationEvents.ClickOnTourNotVerifiedTooltip;


export interface AirCompaniesInTourTipParams {
    airCompaniesNames: Array<string>;
}
